/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoMalattiaCreateDTO
 */
export interface AssistitoMalattiaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaCreateDTO
     */
    tipo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaCreateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaCreateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoMalattiaCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoMalattiaCreateDTO interface.
 */
export function instanceOfAssistitoMalattiaCreateDTO(value: object): value is AssistitoMalattiaCreateDTO {
    return true;
}

export function AssistitoMalattiaCreateDTOFromJSON(json: any): AssistitoMalattiaCreateDTO {
    return AssistitoMalattiaCreateDTOFromJSONTyped(json, false);
}

export function AssistitoMalattiaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoMalattiaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'tipo': json['tipo'] == null ? undefined : json['tipo'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoMalattiaCreateDTOToJSON(value?: AssistitoMalattiaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tipo': value['tipo'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

